/*
 * @author: liqian
 * @date: Do not Edit
 * @description:
 */

// var configUrl = '115.238.71.26:10007';
// var system = {
//   // requestBaseUrl: 'http://192.168.14.164:10005', //本地测试登录
//   // requestBaseUrl: 'http://192.168.14.164:10005', //本地测试请求接口
//   requestBaseUrl: 'http://115.238.71.26:18081', // 235测试接口
//   //requestBaseUrl: 'http://127.0.0.1:10000',
//   requestBaseUrlChat: `http://${configUrl}`,
//   //requestBaseUrl: 'http://beimapro.natapp1.cc',
//   authServerName: "/ptmbio-auth-server",
//   cssServerName: "/ptmbio-css-server",
//   cssApiName: "/ptmbio-css-api",
//   cloudServerName: "/ptmbio-yun-server",
//   chatServiceName: "/css-webchat-service",
//   webSocketBaseUrl: `ws://${configUrl}/css-webchat-service/room/`,
// }

// 生产环境 — https://www.ptm-biolab-css.com.cn
var configUrl = 'www.ptm-biolab-css.com.cn';
var system = {
  requestBaseUrl: 'https://www.ptm-biolab-css.com.cn',
  requestBaseUrlChat: `https://${configUrl}`,
  authServerName: "/ptmbio-auth-server",
  cssServerName: "/ptmbio-css-server",
  cloudServerName: "/ptmbio-yun-server",
  cssApiName: "/ptmbio-css-api",
  chatServiceName: "/css-webchat-service",
  webSocketBaseUrl: `wss://${configUrl}/css-webchat-service/room/`,
}

// 测试环境 (192.168.100.235) - requestBaseUrl 留空，走 config/index.js 的 webpack 代理
// var configUrl = '192.168.100.235:10007';
// var system = {
//   requestBaseUrl: '',
//   requestBaseUrlChat: `http://${configUrl}`,
//   authServerName: "/ptmbio-auth-server",
//   cssServerName: "/ptmbio-css-server",
//   cloudServerName: "/ptmbio-yun-server",
//   cssApiName: "/ptmbio-css-api",
//   chatServiceName: "/css-webchat-service",
//   webSocketBaseUrl: `ws://${configUrl}/css-webchat-service/room/`,
// }

// var configUrl = '192.168.100.233:10007';
// var system = {
//   requestBaseUrl: 'http://192.168.100.233:8989',
//   requestBaseUrlChat: `http://${configUrl}`,
//   authServerName: "/ptmbio-auth-server",
//   cssServerName: "/ptmbio-css-server",
//   cloudServerName: "/ptmbio-yun-server",
//   cssApiName: "/ptmbio-css-api",
//   chatServiceName: "/css-webchat-service",
//   webSocketBaseUrl: `ws://${configUrl}/css-webchat-service/room/`,
// }
export { system }



// WEBPACK FOOTER //
// ./src/api/system.js